import type { ApiUser } from '#/api/userEnvironment/types/ApiUserEnvironment';
import { getLocalStorageJsonItem } from '#/utils/localStorage';

export function isStaff(user: ApiUser | null) {
  if (!user) return false;

  return user?.permissions.includes('staff');
}

export function isAdmin(user: ApiUser | null) {
  if (!user) return false;

  return (user.orgs?.length || 0) > 0;
}

export function isNonAdmin(user: ApiUser | null) {
  if (!user) return true;

  return Boolean(
    !user.permissions.includes('staff') &&
    !user.permissions.includes('orgAdmin'),
  );
}

export function isLocationInCountry(user: ApiUser | null, countryCode: string) {
  return user?.location?.countryCode === countryCode;
}

export function salarySurveyLastSubmittedDate(user: ApiUser | null) {
  if (user) {
    return user.salarySurvey.lastSubmitted;
  }

  const localStorageLastSubmitted = getLocalStorageJsonItem(
    'salarySurveyLastSubmitted',
  );

  if (Array.isArray(localStorageLastSubmitted)) {
    return localStorageLastSubmitted[0] as string | undefined;
  }

  return null;
}
